import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from 'react-router-dom'
import { Modal, Accordion } from 'react-bootstrap';
import moment from 'moment';
import { Drawer, Pagination, Tooltip } from 'antd';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'

import StatusBadge from '../common_component/StatusBadge.js';
import { getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js"
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';
import { useModal } from "../providers/modal-provider.js";

export const ShowCustomer = () => {

    const [state, setstate] = useState(2);
    const containerRef = useRef(null)
    const { theme, dropdownStyleDark } = useTheme()

    const [gstinModalShow, setGstinModalShow] = useState(false);
    const [inputFields, setInputFields] = useState([]);

    const [customer_id, setcustomer_id] = useState("");

    const [navtype, setnavtype] = useState("Overview");
    const [Customer_name, setCustomer_name] = useState("");
    const [Customer_details, setCustomer_details] = useState(null);
    const [customerHistoryDetails, setCustomerHistoryDetails] = useState([]);
    const [open, setOpen] = useState(false);


    const [branchesList, setBranchesList] = useState([])
    const [customerList, setCustomerList] = useState([])

    const [customerListApiState, setCustomerListApiState] = useState(false)
    const [customerHistoryDetailsApiState, setCustomerHistoryDetailsApiState] = useState(false)

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)

    const [customerContactPersons, setCustomerContactPersons] = useState([])
    const [taxDetails, setTaxDetails] = useState([])

    const [transactionReportModalShow, setTransactionReportModalShow] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null)


    const [customerOrderList, setCustomerOrderList] = useState([])
    const [customerOrderListApiState, setCustomerOrderListApiState] = useState(false)

    const daterange_picker_ref_co = useRef()
    const [trmCoListCount, setTrmCoListCount] = useState(0)
    const [trmCoCurrentPage, setTrmCoCurrentPage] = useState(0)
    const [trmCoRowsPerPage, setTrmCoRowsPerPage] = useState(10)
    const [trmCoSortColumn, setTrmCoSortColumn] = useState(null)
    const [trmCoSortValue, setTrmCoSortValue] = useState(null)
    const [trmCoSearchValue, setTrmCoSearchValue] = useState(null)
    const [trmCoStartDate, setTrmCoStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [trmCoEndDate, setTrmCoEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const [customerInvoiceList, setCustomerInvoiceList] = useState([])
    const [customerInvoiceListApiState, setCustomerInvoiceListApiState] = useState(false)

    const daterange_picker_ref_ci = useRef()
    const [trmCiListCount, setTrmCiListCount] = useState(0)
    const [trmCiCurrentPage, setTrmCiCurrentPage] = useState(0)
    const [trmCiRowsPerPage, setTrmCiRowsPerPage] = useState(10)
    const [trmCiSortColumn, setTrmCiSortColumn] = useState(null)
    const [trmCiSortValue, setTrmCiSortValue] = useState(null)
    const [trmCiSearchValue, setTrmCiSearchValue] = useState(null)
    const [trmCiStartDate, setTrmCiStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [trmCiEndDate, setTrmCiEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const apiController = useRef(new AbortController())

    const { openModal, setModalView, setModalData } = useModal()

    var page_name = "customer-list"
    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const setUpDrawer = (tempData) => {
        setOpen(true);
        getCustomerHistoryDetails(tempData.cid)

        setcustomer_id(tempData.cid);

        setCustomer_name(tempData.customer_display_name);
        setnavtype("Overview");

        setCustomerHistoryDetails(tempData.customer_history_details);
        setTaxDetails(tempData.tax_details);
        setCustomerContactPersons(JSON.parse(tempData.contact_persons));
        setCustomer_details(tempData);
    }

    const onClose = () => {
        setOpen(false);

        setcustomer_id("");

        setCustomer_name("");
        setnavtype("Overview");

        setCustomerHistoryDetails([]);
        setTaxDetails(null);
        setCustomerContactPersons([]);
        setCustomer_details(null);
    }

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getCustomers(cp, rpp, search_v) {
        try {
            if (customerListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setCustomerListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/customer-datatable`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            let body = await response.json();
            if (body.operation === "success") {
                setCustomerList(body.data.list);
                setListCount(body.data.count);

                setCustomerListApiState(false)
            }
            else {
                throw "no data"
            }
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    // async function getTimezoneInformation() {
    //     const response = await fetch(
    //         `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
    //     );
    //     const body = await response.json();
    //     if (body.operation === "success") {
    //         if (body.data.length > 0) {
    //             if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
    //                 const timezone = body.data[0].timezone_value;
    //                 set_timezone_change(timezone);
    //                 setStartDate(moment().utcOffset(timezone).subtract(6, "days").format("YYYY-MM-DD"));
    //                 setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
    //             }
    //             else {
    //                 setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
    //                 setEndDate(moment.utc().format("YYYY-MM-DD"));
    //             }
    //         }
    //         else {
    //             setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
    //             setEndDate(moment.utc().format("YYYY-MM-DD"));
    //         }
    //     }
    //     else {
    //         throw "timezone api error"
    //     }
    // }


    async function getBranches() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setBranchesList(body.data)
        }
    }

    async function getCustomerOrderList(cp, rpp, sort_c, sort_v, search_v, sd, ed, customer_id) {
        setCustomerOrderListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-basic-customer-orders-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "start_date": sd, "end_date": ed, "customer_id": customer_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setCustomerOrderList(body.data.list);
            setTrmCoListCount(body.data.count)

            setCustomerOrderListApiState(false)
        }
        else {
            throw "basic customer orders list api error"
        }
    }

    async function getCustomerInvoiceList(cp, rpp, sort_c, sort_v, search_v, sd, ed, customer_id) {
        setCustomerInvoiceListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-basic-customer-invoice-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "start_date": sd, "end_date": ed, "customer_id": customer_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setCustomerInvoiceList(body.data.list);
            setTrmCiListCount(body.data.count)

            setCustomerInvoiceListApiState(false)
        }
        else {
            throw "basic customer invoices list api error"
        }
    }

    async function getCustomerHistoryDetails(cid) {
        setCustomerHistoryDetailsApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-history-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "cid": cid, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setCustomerHistoryDetails(body.data);
        }
        else {
            throw "basic customer hsitory details api error"
        }
        setCustomerHistoryDetailsApiState(false)
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getCustomers(currentPage, rowsPerPage, searchValue)
            // let p2 = getTimezoneInformation()
            let p3 = getBranches()

            Promise.all([p1, p3])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getCustomers(currentPage, rowsPerPage, searchValue)
        }
    }, [currentPage, rowsPerPage, searchValue])


    const changeDealerGSTStatus = (status, id) => {
        var object = {};

        object.unique_id = id
        object.status = status

        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-customer-gst-status`, object, headers).then((res) => {
            if (res.data.operation === "success") {
                handleGstInmodalClose()
                swal("Great!", "Customer GST status changed successfully!", "success")
                getCustomers(currentPage, rowsPerPage, searchValue);
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const makePrimaryGST = (unique_id, dealer_id) => {
        var object = {};

        object.unique_id = unique_id
        object.customer = dealer_id

        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/customer-gst-make-primary`, object, headers).then((res) => {
            if (res.data.operation === "success") {
                handleGstInmodalClose()
                swal("Great!", "Customer GST Preference successfully!", "success")
                getCustomers(currentPage, rowsPerPage, searchValue);
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleGstInmodalClose = () => {
        setInputFields([]);
        setGstinModalShow(false);
    }

    const submitStatus = (id, status) => {
        let values = { "id": id, "status": status, "page_name": page_name, "organization_id": organization_id };

        console.log(values);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-status-customer`, values, headers).then((res) => {
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Status changed successfully!", "success")
                getCustomers(currentPage, rowsPerPage, searchValue);

            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    function scrollLeft() {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                left: -100,
                behavior: "smooth",
            });
        }
    }

    function scrollRight() {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                left: 100,
                behavior: "smooth",
            });
        }
    }



    const handleTransactionReportModalClose = () => {
        setTransactionReportModalShow(false)
        setSelectedCustomer(null)

        setCustomerOrderList([])

        setTrmCoListCount(0)
        setTrmCoCurrentPage(0)
        setTrmCoRowsPerPage(10)
        setTrmCoSortColumn(null)
        setTrmCoSortValue(null)
        setTrmCoSearchValue(null)
        setTrmCoStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
        setTrmCoEndDate(moment.utc().format("YYYY-MM-DD"))


        setCustomerInvoiceList([])

        setTrmCiListCount(0)
        setTrmCiCurrentPage(0)
        setTrmCiRowsPerPage(10)
        setTrmCiSortColumn(null)
        setTrmCiSortValue(null)
        setTrmCiSearchValue(null)
        setTrmCiStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
        setTrmCiEndDate(moment.utc().format("YYYY-MM-DD"))
    }

    useEffect(() => {
        if (state == 1) {
            getCustomerOrderList(trmCoCurrentPage, trmCoRowsPerPage, trmCoSortColumn, trmCoSortValue, trmCoSearchValue, trmCoStartDate, trmCoEndDate, selectedCustomer)
        }
    }, [trmCoCurrentPage, trmCoRowsPerPage, trmCoSortColumn, trmCoSortValue, trmCoSearchValue, trmCoStartDate, trmCoEndDate])

    useEffect(() => {
        if (state == 1) {
            getCustomerInvoiceList(trmCiCurrentPage, trmCiRowsPerPage, trmCiSortColumn, trmCiSortValue, trmCiSearchValue, trmCiStartDate, trmCiEndDate, selectedCustomer)
        }
    }, [trmCiCurrentPage, trmCiRowsPerPage, trmCiSortColumn, trmCiSortValue, trmCiSearchValue, trmCiStartDate, trmCiEndDate])


    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Show Customers</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/customer`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <Link to={`/add-customer`} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
                                    </path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Add Customer</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <div className="card mb-5 mb-xl-8">
                                <div className="card-body py-3">
                                    <div className='mb-5'>
                                        <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                    </div>
                                    <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                        {
                                            customerListApiState ?
                                                <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                :
                                                customerList.length > 0 ?
                                                    <>
                                                        <div className="mb-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                showQuickJumper={true}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                            />
                                                        </div>
                                                        <div className='overflow-auto w-100 flex-grow-1'>
                                                            <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }} >
                                                                <thead>
                                                                    <tr className="fw-bold text-muted">
                                                                        <th className="min-w-150px">Name</th>
                                                                        <th className="min-w-150px">Company Name</th>
                                                                        <th className="min-w-150px">Email</th>
                                                                        <th className="min-w-150px">Work Phone</th>
                                                                        <th className="min-w-150px">Lead Source</th>
                                                                        <th className="min-w-150px">Status</th>
                                                                        <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        customerList.map((obj, indx) => {
                                                                            return (
                                                                                <tr key={obj.cid}>
                                                                                    <td>
                                                                                        <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6 d-flex align-items-center gap-2"><span>{obj.customer_display_name}</span><i className="fa-solid fa-eye fs-2 p-0 text-hover-primary cursor-pointer" onClick={() => { setUpDrawer(obj) }}> </i></span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className="badge badge-light-info">{obj.company_name ? obj.company_name : "NA"}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className="badge badge-secondary">{obj.email ? obj.email : "NA"}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className="badge badge-light-info">{obj.work_phone}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span className="badge badge-secondary">{obj.lead_source}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <StatusBadge status={obj.add_status} entity={""} />
                                                                                    </td>
                                                                                    <td className="sticky-column">
                                                                                        <div className="dropdown">
                                                                                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                                <i className="fas fa-bars px-0"></i>
                                                                                            </button>
                                                                                            {
                                                                                                write &&
                                                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                    <li><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => { setUpDrawer(obj) }}>View Details</div></li>
                                                                                                    <li className="py-1"><Link className="dropdown-item" to={`/new-payment-received/customer/${obj.cid}`}>New Payment Received</Link></li>
                                                                                                    {<li className="py-1"><Link className="dropdown-item" to={`/edit-customer-details/${obj.cid}`}>Edit Details</Link></li>}
                                                                                                    {<li className="py-1"><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={(e) => { setInputFields(obj.tax_details); setcustomer_id(obj.cid); setGstinModalShow(true); }}>GSTIN Details</div></li>}
                                                                                                    {<li className="py-1"><Link to={`/customer-address-details/${obj.cid}`} className="dropdown-item">Update Addresses</Link></li>}
                                                                                                    {
                                                                                                        <li><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={(e) => {
                                                                                                            swal({
                                                                                                                title: "Are you sure?",
                                                                                                                text: "Status will be changed to " + (obj.add_status == "Active" ? "Deactive" : "Active"),
                                                                                                                icon: "warning",
                                                                                                                buttons: true,
                                                                                                                dangerMode: true,
                                                                                                            })
                                                                                                                .then((willDelete) => {
                                                                                                                    if (willDelete) {
                                                                                                                        submitStatus(obj.cid, (obj.add_status == "Active" ? "Deactive" : "Active"));
                                                                                                                    }
                                                                                                                });
                                                                                                        }}>Change Status</div></li>
                                                                                                    }
                                                                                                    {
                                                                                                        <li className="py-1">
                                                                                                            <div className="dropdown-item" style={{ cursor: "pointer" }}
                                                                                                                onClick={(e) => {
                                                                                                                    setTransactionReportModalShow(true);
                                                                                                                    setSelectedCustomer(obj.cid);
                                                                                                                    getCustomerOrderList(trmCoCurrentPage, trmCoRowsPerPage, trmCoSortColumn, trmCoSortValue, trmCoSearchValue, trmCoStartDate, trmCoEndDate, obj.cid);
                                                                                                                    getCustomerInvoiceList(trmCiCurrentPage, trmCiRowsPerPage, trmCiSortColumn, trmCiSortValue, trmCiSearchValue, trmCiStartDate, trmCiEndDate, obj.cid);
                                                                                                                }}
                                                                                                            >Transaction Reports
                                                                                                            </div>
                                                                                                        </li>
                                                                                                    }
                                                                                                </ul>
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="mt-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-muted fs-2 my-auto text-center">No data to be shown</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div >

            <Modal show={gstinModalShow} onHide={() => { setGstinModalShow(false); setcustomer_id("") }} size="lg" centered>
                <Modal.Header className='py-2'>
                    <Modal.Title>GSTIN Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGstinModalShow(false); setcustomer_id("") }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
                    <div className="container mt-5">
                        {!inputFields.length ? (
                            <div className="overflow-auto pb-5">
                                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6 shadow-sm">
                                    <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
                                            <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
                                        </svg>
                                    </span>
                                    <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                        <div className="mb-3 mb-md-0 fw-semibold">
                                            <h4 className="text-gray-900 fw-bold">No GST Data Available.</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            inputFields.map((obj, index) => (
                                <div key={index} className="d-flex flex-column gap-5 mb-4">
                                    <div className="fv-row w-100 flex-md-root">
                                        <div className="card card-flush h-lg-100 shadow-sm">

                                            <div className="card-header mt-6 rounded-top">
                                                <div className="card-title d-flex justify-content-between align-items-start">
                                                    <h3 className="fw-bolder mb-1">{obj.GstIn}</h3>
                                                </div>
                                                <div className="card-toolbar">
                                                    <div className="d-flex flex-column align-items-end">
                                                        <span className={`badge badge-light-${obj.flag === "Primary" ? "primary" : "warning"} rounded mb-1`}>{obj.flag}</span>
                                                        <span className={`badge badge-light-${obj.gstin_add_status === "Active" ? "success" : "secondary"} rounded mb-1`}>{obj.gstin_add_status}</span>
                                                    </div>
                                                    <div className="dropdown ps-2">
                                                        {write && obj.flag !== "Primary" && (
                                                            <>
                                                                <button className="btn btn-sm btn-light rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <i className="fas fa-bars px-0"></i>
                                                                </button>
                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                    {obj.gst_treatment !== "Consumer" && obj.gst_treatment !== "Unregistered Business" && obj.gstin_add_status !== "Deactivated" && (
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => {
                                                                                swal({
                                                                                    title: "Are you sure?",
                                                                                    text: "GST will be set to Primary",
                                                                                    icon: "warning",
                                                                                    buttons: true,
                                                                                    dangerMode: true,
                                                                                }).then((willDelete) => {
                                                                                    if (willDelete) {
                                                                                        makePrimaryGST(obj.unique_id, customer_id);
                                                                                    }
                                                                                });
                                                                            }}
                                                                        >
                                                                            Make Primary
                                                                        </button>
                                                                    )}
                                                                    <button
                                                                        onClick={() => {
                                                                            swal({
                                                                                title: "Are you sure?",
                                                                                text: "GST status will be set to " + (obj.gstin_add_status === "Active" ? "Deactivated" : "Active"),
                                                                                icon: "warning",
                                                                                buttons: true,
                                                                                dangerMode: true,
                                                                            }).then((willDelete) => {
                                                                                if (willDelete) {
                                                                                    changeDealerGSTStatus(obj.gstin_add_status === "Active" ? "Deactivated" : "Active", obj.unique_id);
                                                                                }
                                                                            });
                                                                        }}
                                                                        className="dropdown-item"
                                                                    >
                                                                        Change Status
                                                                    </button>
                                                                </ul>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-wrap">
                                                <div className="card-body p-5">
                                                    {obj.legal_name && (
                                                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3 bg-light shadow-sm">
                                                            <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                            <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                        </div>
                                                    )}
                                                    <div className="row">
                                                        <div className="col-md-6 col-sm-12 mb-2">
                                                            <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3 bg-light shadow-sm">
                                                                <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3 bg-light shadow-sm">
                                                                <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                <div className="fw-semibold text-gray-400">Place of Supply</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button
                        className='btn btn-success'
                        onClick={() => {
                            setGstinModalShow(false)

                            setModalData({
                                apiCallback: () => { getCustomers(currentPage, rowsPerPage, searchValue) },
                                entityType: "CUSTOMER",
                                entityId: customer_id,
                                page_name,
                            })
                            setModalView("GSTIN_MODAL")
                            openModal()

                            setcustomer_id("")
                        }}
                    >
                        <i className="las la-plus"></i>
                        Add New
                    </button>
                    <button className="btn btn-danger rounded" onClick={() => { setGstinModalShow(false); setcustomer_id("") }}>Close</button>
                </Modal.Footer>
            </Modal >

            <Modal show={transactionReportModalShow} onHide={() => { handleTransactionReportModalClose() }} dialogClassName="h-modal-90" >
                <Modal.Header>
                    <Modal.Title>Transaction Reports</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleTransactionReportModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container-fluid'>

                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <div className='d-flex align-items-center justify-content-between w-100 px-2'>
                                        <h3>Orders</h3>
                                        <Link to={{ pathname: "/create-customer-order", state: { customerId: selectedCustomer } }} className="btn btn-primary btn-sm" >Add +</Link>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>

                                    <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                        <div className=''>
                                            <DateRangePickerComponent
                                                ref={daterange_picker_ref_co}
                                                allowEdit={false}
                                                showClearButton={false}
                                                focus={() => { daterange_picker_ref_co.current.show() }}
                                                delayUpdate={true}
                                                presets={[
                                                    { label: 'Today', start: new Date(), end: new Date() },
                                                    { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                    { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                    { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                                ]}
                                                change={(e) => {
                                                    setTrmCoStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                    setTrmCoEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                }}
                                                startDate={new Date(trmCoStartDate)}
                                                endDate={new Date(trmCoEndDate)}
                                            />
                                        </div>
                                    </div>

                                    <div className="card mb-5 mb-xl-8">
                                        <div className="card-header border-0 pt-5">
                                            <h3 className="card-title align-items-start flex-column">
                                                <span className="card-label fw-bold fs-3 mb-1">Orders</span>
                                                <span className="text-muted mt-1 fw-semibold fs-7">Over {customerOrderList.length} Orders</span>
                                            </h3>
                                            <div className="card-toolbar">
                                                <Pagination
                                                    total={trmCoListCount}
                                                    onChange={(page, pageSize) => {
                                                        console.log(page, pageSize)
                                                        setTrmCoCurrentPage(page);
                                                        setTrmCoRowsPerPage(pageSize);
                                                    }}
                                                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                    pageSize={trmCoRowsPerPage}
                                                    current={trmCoCurrentPage}
                                                    showSizeChanger={true}
                                                    showQuickJumper={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="card-body py-3">
                                            <div className="table-responsive" style={{ minHeight: "200px" }}>
                                                <div className='m-5'><input type="text" className='form-control fw-bold border border-primary' value={trmCoSearchValue === null ? "" : trmCoSearchValue} onChange={(e) => { setTrmCoSearchValue(e.target.value) }} placeholder='Search Customer Orders...' /></div>

                                                <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                                    <thead>
                                                        <tr className="fw-bold text-muted">
                                                            <th className="min-w-100px">Order Number</th>
                                                            <th className="min-w-100px">Reference Number</th>
                                                            <th className="min-w-100px">Branch</th>
                                                            <th className="min-w-100px">Grand Total</th>
                                                            <th className="min-w-100px">Order Date</th>
                                                            <th className="min-w-100px">Due Date</th>
                                                            <th className="min-w-100px">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            customerOrderListApiState ? <tr><td colSpan={7} className="text-center pt-10"><div className="spinner-border text-primary"></div></td></tr> :
                                                                customerOrderList.length === 0 ? <tr><td colSpan={7} className="text-center"><h3 className="text-muted pt-6">No data to be shown</h3></td></tr> :
                                                                    customerOrderList.map((obj, indx) => {
                                                                        return (
                                                                            <tr key={indx} className='bg-hover-secondary' onClick={() => {
                                                                                window.location.href = `/view-customer-order/${obj.customer_order_id}`
                                                                            }}>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{obj.customer_order_number}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{obj.reference_number ? obj.reference_number : "NA"}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{branchesList.find(x => x.branch_id == obj.branch_id).branch_name}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{obj.order_currency.currency_symbol + " " + obj.grand_total}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{moment(obj.order_date).format("DD-MM-YYYY")}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{moment(obj.due_date).format("DD-MM-YYYY")}</span></td>
                                                                                <td><StatusBadge status={obj.add_status} entity={"CUSTOMER_ORDER"} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <div className='d-flex align-items-center justify-content-between w-100 px-2'>
                                        <h3>Invoices</h3>
                                        <Link to={{ pathname: "/create-customer-invoice", state: { customerId: selectedCustomer } }} className="btn btn-primary btn-sm d-inline-block" >Add +</Link>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>

                                    <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                        <div className=''>
                                            <DateRangePickerComponent
                                                ref={daterange_picker_ref_ci}
                                                allowEdit={false}
                                                showClearButton={false}
                                                focus={() => { daterange_picker_ref_ci.current.show() }}
                                                delayUpdate={true}
                                                presets={[
                                                    { label: 'Today', start: new Date(), end: new Date() },
                                                    { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                    { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                    { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                                ]}
                                                change={(e) => {
                                                    setTrmCiStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                    setTrmCiEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                }}
                                                startDate={new Date(trmCiStartDate)}
                                                endDate={new Date(trmCiEndDate)}
                                            />
                                        </div>
                                    </div>

                                    <div className="card mb-5 mb-xl-8">
                                        <div className="card-header border-0 pt-5">
                                            <h3 className="card-title align-items-start flex-column">
                                                <span className="card-label fw-bold fs-3 mb-1">Invoices</span>
                                                <span className="text-muted mt-1 fw-semibold fs-7">Over {customerInvoiceList.length} Invoices</span>
                                            </h3>
                                            <div className="card-toolbar">
                                                <Pagination
                                                    total={trmCiListCount}
                                                    onChange={(page, pageSize) => {
                                                        setTrmCiCurrentPage(page);
                                                        setTrmCiRowsPerPage(pageSize);
                                                    }}
                                                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                    pageSize={trmCiRowsPerPage}
                                                    current={trmCiCurrentPage}
                                                    showSizeChanger={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="card-body py-3">
                                            <div className="table-responsive" style={{ minHeight: "200px" }}>
                                                <div className='m-5'><input type="text" className='form-control fw-bold border border-primary' value={trmCiSearchValue === null ? "" : trmCiSearchValue} onChange={(e) => { setTrmCiSearchValue(e.target.value) }} placeholder='Search Customer Orders...' /></div>

                                                <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                                    <thead>
                                                        <tr className="fw-bold text-muted">
                                                            <th className="min-w-100px">Invoice Number</th>
                                                            <th className="min-w-100px">Reference Number</th>
                                                            <th className="min-w-100px">Branch</th>
                                                            <th className="min-w-100px">Grand Total</th>
                                                            <th className="min-w-100px">Invoice Date</th>
                                                            <th className="min-w-100px">Due Date</th>
                                                            <th className="min-w-100px">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            customerInvoiceListApiState ? <tr><td colSpan={7} className="text-center pt-10"><div className="spinner-border text-primary"></div></td></tr> :
                                                                customerInvoiceList.length === 0 ? <tr><td colSpan={7} className="text-center"><h3 className="text-muted pt-6">No data to be shown</h3></td></tr> :
                                                                    customerInvoiceList.map((obj, indx) => {
                                                                        return (
                                                                            <tr key={indx} className='bg-hover-secondary' onClick={() => {
                                                                                window.location.href = `/view-customer-invoice/${obj.customer_invoice_id}`
                                                                            }}>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{obj.customer_invoice_number}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{obj.reference_number ? obj.reference_number : "NA"}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{branchesList.find(x => x.branch_id == obj.branch_id).branch_name}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{obj.invoice_currency.currency_symbol + " " + obj.grand_total}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{moment(obj.invoice_date).format("DD-MM-YYYY")}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary fs-6">{moment(obj.due_date).format("DD-MM-YYYY")}</span></td>
                                                                                <td><StatusBadge status={obj.add_status} entity={"CUSTOMER_INVOICE"} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleTransactionReportModalClose() }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Drawer width={window.innerWidth > 1000 ? "50%" : window.innerWidth - 100} className="bg-body" style={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open}
                title={
                    <span className='text-dark'>{Customer_name}</span>
                }
            // extra={
            //     <Space>
            //         <div className="dropdown">
            //             <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            //                 <i className="fas fa-bars px-0"></i>
            //             </button>
            //             {write &&
            //                 <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            //                     <li><Link className="dropdown-item" to={`/edit-customer-details/${customer_id}`}>Edit Details</Link></li>
            //                     <Link onClick={(e) => { setInputFields(Customer_details); setGstinModalShow(true); }} className="dropdown-item">GSTIN Details</Link>
            //                     <Link to={`/customer-address-details/${customer_id}`} className="dropdown-item">Update Addresses</Link>
            //                     <li><a className="dropdown-item" onClick={(e) => { setStatusId(customer_id); setStatusValue(Customer_details[0].add_status); setStatusModalShow(true); }}>Change Status</a></li>
            //                 </ul>
            //             }
            //         </div>
            //     </Space>
            // }
            >
                <div className="card">
                    <div className="d-flex align-items-center">
                        <button className="btn btn-icon btn-active-color-primary border-0" onClick={scrollLeft}>
                            <i className="fas fa-chevron-left"></i>
                        </button>
                        <div className="d-flex w-100 overflow-auto" ref={containerRef}>
                            <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                                <li className="nav-item mx-lg-1">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "GST" && "active"}`} onClick={(e) => { setnavtype("GST"); }}>GST Details</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Contact" && "active"}`} onClick={(e) => { setnavtype("Contact"); }}>Contact</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                                </li>
                            </ul>
                        </div>
                        <button className="btn btn-icon btn-active-color-primary border-0" onClick={scrollRight}>
                            <i className="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
                <div className="card" id="kt_profile_details_view">
                    {
                        navtype === "Overview" ?
                            <>
                                {
                                    Customer_details &&
                                    <div className="card-body p-9">
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Customer Type</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">{Customer_details.customer_type}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Company Name</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{Customer_details.company_name}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Status
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                {Customer_details.add_status === "Active" ?
                                                    <span className="badge badge-success">{Customer_details.add_status}</span>
                                                    :
                                                    <span className="badge badge-danger">{Customer_details.add_status}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Mobile</label>
                                            <div className="col-lg-8">
                                                <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Customer_details.mobile}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Work Phone</label>
                                            <div className="col-lg-8">
                                                <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Customer_details.work_phone}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Email</label>
                                            <div className="col-lg-8">
                                                <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Customer_details.email}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Website</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{Customer_details.website}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Designation
                                            </label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">{Customer_details.designation}</span>
                                            </div>
                                        </div>
                                        {
                                            <>
                                                <div className="row mb-3">
                                                    <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                                    <div className="col-lg-8">
                                                        {/* <span className="fw-bold fs-6 text-gray-800">{JSON.parse(Customer_details.currency).currency_code}</span> */}
                                                    </div>
                                                </div>
                                                <div className="row mb-10">
                                                    <label className="col-lg-4 fw-semibold text-muted">Lead Source</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-semibold fs-6 text-gray-800">{Customer_details.lead_source}</span>
                                                    </div>
                                                </div>

                                                <div className="row mb-3">
                                                    <label className="col-lg-4 fw-semibold text-muted">state</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-semibold fs-6 text-gray-800">{Customer_details.addresses.length && Customer_details.addresses.find(x => x.address_type === "billing")?.state || "NA"}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-lg-4 fw-semibold text-muted">Country</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-semibold fs-6 text-gray-800">{Customer_details.addresses.length && Customer_details.addresses.find(x => x.address_type === "billing")?.country || "NA"}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-lg-4 fw-semibold text-muted">Remarks</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-semibold fs-6 text-gray-800">{Customer_details.remarks}</span>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                }
                            </>
                            :

                            navtype === "GST" ?
                                <>
                                    {
                                        Customer_details && (
                                            <div className="card-body p-3">
                                                {
                                                    taxDetails.length ?
                                                        taxDetails.map(obj => {
                                                            return (
                                                                <div className="my-3" key={obj.unique_id}>
                                                                    <div className="card h-100" style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                                                        <div className="d-flex flex-wrap">
                                                                            <div className="card-body p-3">
                                                                                <div className="border border-primary rounded p-2 mb-2 bg-light">
                                                                                    {obj.gst_treatment !== "Consumer" && obj.gst_treatment !== "Unregistered Business" ? (
                                                                                        <>
                                                                                            <div className="card-title mb-1">
                                                                                                <h6 className="fw-bold text-primary">GST IN: {obj.GstIn}</h6>
                                                                                            </div>
                                                                                            <div className="mb-1">
                                                                                                <span className="fw-bold text-dark">{obj.legal_name}</span>
                                                                                                <div className="text-muted">Business Legal Name</div>
                                                                                            </div>
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 col-sm-12 mb-2">
                                                                                                    <div className="border border-primary rounded p-2 bg-light h-100">
                                                                                                        <span className="fw-bold text-dark">{obj.gst_treatment}</span>
                                                                                                        <div className="text-muted">GST Treatment</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-md-6 col-sm-12">
                                                                                                    <div className="border border-primary rounded p-2 bg-light h-100">
                                                                                                        <span className="fw-bold text-dark">{obj.place_of_supply}</span>
                                                                                                        <div className="text-muted">Place of Supply</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <div className="fw-bold text-dark">{obj.gst_treatment}</div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        <div className="text-center text-muted">No GSTIn details available</div>
                                                }
                                            </div>
                                        )
                                    }
                                </>
                                :
                                navtype === "Contact" ?
                                    <>
                                        {
                                            Customer_details && (
                                                <div className="card-body p-9" style={{ overflow: "auto", maxHeight: "400px" }}>
                                                    {
                                                        customerContactPersons.every(obj => !obj.salutation && !obj.firstName && !obj.lastName && !obj.email && !obj.workPhone && !obj.mobile && !obj.designation && !obj.department) ? (
                                                            <div
                                                                className="empty-data-box"
                                                                style={{ border: "1px solid #ddd", padding: "20px", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", textAlign: "center", }}
                                                            >
                                                                NO CONTACT ASSOCIATED.
                                                            </div>
                                                        ) : (
                                                            <div className="container" style={{ minWidth: "max-content" }}>
                                                                {customerContactPersons.map((obj, indx) => (
                                                                    <div
                                                                        key={indx}
                                                                        className="contact-box"
                                                                        style={{ border: "1px solid #ddd", padding: "10px", margin: "10px 0", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", }}
                                                                    >
                                                                        <div>
                                                                            <strong>Name: </strong>
                                                                            {obj.salutation + " " + obj.firstName + " " + obj.lastName}
                                                                        </div>
                                                                        <div>
                                                                            <strong>Email: </strong>
                                                                            {obj.email}
                                                                        </div>
                                                                        <div>
                                                                            <strong>Work Phone: </strong>
                                                                            {obj.workPhone}
                                                                        </div>
                                                                        <div>
                                                                            <strong>Mobile: </strong>
                                                                            {obj.mobile}
                                                                        </div>
                                                                        <div>
                                                                            <strong>Designation: </strong>
                                                                            {obj.designation}
                                                                        </div>
                                                                        <div>
                                                                            <strong>Department: </strong>
                                                                            {obj.department}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            )}
                                    </>
                                    :
                                    navtype === "History" &&
                                    <>
                                        {
                                            Customer_details &&
                                            <div className="card-body p-9">
                                                {
                                                    customerHistoryDetailsApiState ? <img src="/images/loader-06.svg" alt="" style={loaderstyle} /> :
                                                        customerHistoryDetails.length ?
                                                            customerHistoryDetails.map((obj, index) => {
                                                                return (
                                                                    <div key={index}>
                                                                        <div className="m-0">
                                                                            <div className="d-flex align-items-sm-center mb-5">
                                                                                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                                    <div className="flex-grow-1 me-2">
                                                                                        {obj.operation === "add" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span> : <span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="timeline">
                                                                                <div className="timeline-item align-items-center mb-7">
                                                                                    <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                        <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                        <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                                    </svg>
                                                                                    </span>
                                                                                    <div className="timeline-content m-0">
                                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                        <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="timeline-item align-items-center">
                                                                                    <div className="timeline-line w-40px"></div>
                                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                        <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                        <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                                    </svg>
                                                                                    </span>
                                                                                    <div className="timeline-content m-0">
                                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                        <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {customerHistoryDetails.length > 1 &&
                                                                            <div className="separator separator-dashed my-6"></div>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            "No History Details to be shown"
                                                }
                                            </div>
                                        }
                                    </>
                    }
                </div>
            </Drawer>
        </>
    );
};
export default ShowCustomer;